import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/scientific_questions';

export default {
  add(question, succ) {
    axios.post(INDEX_URL, { scientific_question: question })
      .then(() => { succ(); });
  },
  index(succ) {
    axios.get(INDEX_URL)
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/questions.js